import type { SearchPageOpenParams } from '../analytics';
import { addOffersCountToEvent } from '../analytics-data-extraction/search-page';
import { sendEvent } from './lib';

/**
 * flights_serp_page_opened - Экран выдачи поиска
 */
export const serpPageOpened = (params: SearchPageOpenParams) => {
  if (!params.searchQuery) {
    return;
  }

  let status: 'success' | 'error' | 'blank';
  if (!params.success) {
    status = 'error';
  } else if (!params.offers || params.offers.length === 0) {
    status = 'blank';
  } else {
    status = 'success';
  }

  const directFlights =
    params.offers?.filter(
      offer =>
        offer.flights.every(f => f.segments.length === 1) &&
        offer.flights.every(f => f.segments.every(s => s.stops.count === 0)),
    ) || [];
  const layoverFlights =
    params.offers?.filter(
      offer =>
        offer.flights.some(f => f.segments.length > 1) ||
        offer.flights.some(f => f.segments.some(s => s.stops.count > 0)),
    ) || [];

  const eventProps = {
    city_from: params.searchQuery.cityFrom,
    airport_from: params.searchQuery.airportFrom,
    city_to: params.searchQuery.cityTo,
    airport_to: params.searchQuery.airportTo,
    date_from: params.searchQuery.dateFrom,
    date_to: params.searchQuery.dateTo,
    class: params.searchQuery.cabinClass === 'E' ? 'economy' : 'business',
    count_passenger_adult: params.searchQuery.passengerAdult,
    count_passenger_youth: params.searchQuery.passengerYouth,
    count_passenger_child: params.searchQuery.passengerChild,
    count_passenger_total: params.searchQuery.passengerTotal,
    status,
    with_layovers_count: layoverFlights.length,
    without_layovers_count: directFlights.length,
    сount_offer: params.offers?.length || 0,
    source_screen: params.source,
  };

  if (params.offers && params.offers.length > 0) {
    addOffersCountToEvent(eventProps, params.offers);
  }

  sendEvent('flights_serp_page_opened', eventProps);
};
